









import { Component, Vue, Emit, Inject } from 'vue-property-decorator'
import { getSearchHot } from '../../search-service' //请求接口
import { namespace } from 'vuex-class'
import { isMmz } from '@/app/core/utils'
const searchModule = namespace('search') //vuex

@Component({})
export default class SearchHot extends Vue {
  hot: any[] = []
  shareEarn = this.$route.query.shareEarn

  @searchModule.Action addSearchRecords!: (searchKey: string) => void

  @Inject({ from: 'useHotEP', default: null }) useHotEP!: any
  useHotExposure(item: any) {
    const { keyword } = item
    return this.useHotEP && this.useHotEP({keyword: keyword})
  }
  @Emit('useHot')
  useHot(item: any) {
    const { keyword } = item
    this.addSearchRecords(keyword)
    const isMMz = isMmz()
    this.$router.push({ name: 'searchRes', query: {  hzwMmz: isMMz ? '1' : '', searchKey: keyword ,refresh: 'no',cmd: 'share',sharetype: '0', shareEarn: this.shareEarn } })
  }

  async created() {
    this.hot = await getSearchHot()
  }
}
